module.exports = __webpack_public_path__ + "img/dotted-line.400bf56d.svg";